import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { campaignAction } from "../../../store/campaign-store";
import { cuteToast } from "../../UI/cute";

const GalleryURL = (props) => {
  const inputRef = useRef();

  const dispatch = useDispatch();

  const single_layer = useSelector((state) => state.campaign.single_layer);

  const editSlideData = useSelector((state) => state.campaign.editSlideData);
  const { toggleRightshow } = props;
  const {
    error,
    setError,
    status: httpStatusCode,
    sendRequest: insertImageURL,
  } = useHttp();

  const responseData = async (response) => {
    if (response.url) {
      let new_layer_data = { ...single_layer };
      new_layer_data.src = response.url;

      await dispatch(
        campaignAction.setSingleLayerData({ data: new_layer_data })
      );

      await dispatch(
        campaignAction.setSingleSlideData({ layer_name: single_layer.name })
      );

      dispatch(campaignAction.appendVideoData());
      dispatch(campaignAction.setImageLoadedS3({ is_loaded_img: false }));

      // if (
      //   active_slide_name === "slide_1" ||
      //   active_slide_name === "slide_2" ||
      //   active_slide_name === "slide_3"
      // ) {
      var newData = { ...editSlideData };

      newData.logo = response.url;
      dispatch(campaignAction.setSlideData({ data: newData }));
      // }

      toggleRightshow();
    }
    setError(null);
  };

  if (error) {
    console.log(error);
  }
  const uploadIMageURL = () => {
    var url = inputRef.current.value.trim();

    if (url) {
      if (single_layer.name.indexOf("bg_image") === 0) {
        dispatch(campaignAction.setImageEditor({ content: url }));
        toggleRightshow();
      } else {
        if (url) {
          insertImageURL(
            {
              url: endPoints.fetchImageURL,
              method: "POST",
              body: { url: url },
            },
            responseData
          );
        }
      }
    } else {
      inputRef.current.focus();
      cuteToast({
        type: "error",
        message: "Please enter the URL",
        timer: 5000,
        title: "",
      });
    }
  };
  return (
    <>
      <div className="imageurl_bx">
        <h6>Image Url</h6>
        <input
          ref={inputRef}
          name=""
          type="text"
          className="form-control"
          placeholder="Enter URL"
        />
        {error && httpStatusCode === 404 && (
          <p className="text-danger pull-right">{error}</p>
        )}
      </div>

      <div className="text-center pt-5">
        <input
          onClick={uploadIMageURL}
          type="button"
          className="btn btn3"
          value="Apply Image"
        />
      </div>
    </>
  );
};

export default GalleryURL;
